// 延迟加载插件 - 独立脚本（不依赖 DOMContentLoaded）
(function() {
  'use strict';

  // 配置延迟时间（毫秒）
  const CONFIG = {
    chatwayDelay: 5000,  // Chatway 延迟 5 秒
    modalDelay: 8000,    // 弹窗表单延迟 8 秒
    checkInterval: 100,  // 检查间隔 100ms
    maxChecks: 100       // 最多检查 100 次（10秒）
  };

  // 标记插件是否已经找到
  let chatwayFound = false;
  let modalFound = false;

  // 使用 MutationObserver 监听 DOM 变化，立即隐藏插件
  const hidePluginsImmediately = () => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // 隐藏 Chatway
            if (node.classList && node.classList.contains('chatway--container')) {
              node.style.cssText = 'display: none !important; visibility: hidden !important;';
              node.setAttribute('data-yg-hidden', 'true');
              chatwayFound = true;
            }
            
            // 隐藏弹窗表单
            if (node.classList && node.classList.contains('react-responsive-modal-root')) {
              node.style.cssText = 'display: none !important; visibility: hidden !important;';
              node.setAttribute('data-yg-hidden', 'true');
              modalFound = true;
            }

            // 检查子元素
            const chatwayInside = node.querySelector && node.querySelector('.chatway--container');
            if (chatwayInside) {
              chatwayInside.style.cssText = 'display: none !important; visibility: hidden !important;';
              chatwayInside.setAttribute('data-yg-hidden', 'true');
              chatwayFound = true;
            }

            const modalInside = node.querySelector && node.querySelector('.react-responsive-modal-root');
            if (modalInside) {
              modalInside.style.cssText = 'display: none !important; visibility: hidden !important;';
              modalInside.setAttribute('data-yg-hidden', 'true');
              modalFound = true;
            }
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    return observer;
  };

  // 启动观察器
  const observer = hidePluginsImmediately();

  // 延迟显示 Chatway
  const showChatway = () => {
    let checks = 0;
    const checkChatway = setInterval(() => {
      checks++;
      const chatwayContainer = document.querySelector('.chatway--container[data-yg-hidden="true"]');
      
      if (chatwayContainer || chatwayFound) {
        clearInterval(checkChatway);
        const element = chatwayContainer || document.querySelector('.chatway--container');
        
        if (element) {
          setTimeout(() => {
            element.removeAttribute('data-yg-hidden');
            element.classList.add('yg-plugin-loaded');
            element.removeAttribute('style');
            element.style.opacity = '0';
            element.style.transition = 'opacity 0.5s ease-in';
            
            setTimeout(() => {
              element.style.opacity = '1';
            }, 50);
          }, CONFIG.chatwayDelay);
        }
      } else if (checks >= CONFIG.maxChecks) {
        clearInterval(checkChatway);
      }
    }, CONFIG.checkInterval);
  };

  // 延迟显示弹窗表单
  const showModal = () => {
    let checks = 0;
    const checkModal = setInterval(() => {
      checks++;
      const modalRoot = document.querySelector('.react-responsive-modal-root[data-yg-hidden="true"]');
      
      if (modalRoot || modalFound) {
        clearInterval(checkModal);
        const element = modalRoot || document.querySelector('.react-responsive-modal-root');
        
        if (element) {
          setTimeout(() => {
            element.removeAttribute('data-yg-hidden');
            element.classList.add('yg-plugin-loaded');
            element.removeAttribute('style');
            element.style.opacity = '0';
            element.style.transition = 'opacity 0.5s ease-in';
            
            setTimeout(() => {
              element.style.opacity = '1';
            }, 50);
          }, CONFIG.modalDelay);
        }
      } else if (checks >= CONFIG.maxChecks) {
        clearInterval(checkModal);
      }
    }, CONFIG.checkInterval);
  };

  // 页面加载完成后开始延迟显示
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      showChatway();
      showModal();
      
      setTimeout(() => {
        observer.disconnect();
      }, Math.max(CONFIG.chatwayDelay, CONFIG.modalDelay) + 2000);
    });
  } else {
    showChatway();
    showModal();
    
    setTimeout(() => {
      observer.disconnect();
    }, Math.max(CONFIG.chatwayDelay, CONFIG.modalDelay) + 2000);
  }

})();

